<template>
  <!-- EDITACE ZARIZENI NA DETAILU ZARIZENI -->
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <!-- kvůli zanořeným modalům pro transformační funkce potřebuju z-index 0 vždy -->
    <div
      v-if="editedDevice != undefined"
      :class="{
        opened: opened.indexOf('editMqttDevice') >= 0,
        'last-active': opened.indexOf('editMqttDevice') == opened.length - 1
      }"
      class="side-box__inner"
      style="z-index: 0"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEditConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runEdit()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozitZarizeni") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ device.custDeviceName }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.device" class="text-danger">
          {{ errors.device }}
        </div>
        <div class="my-4">
          <a
            :class="{ opened: infoOpened }"
            class="atom-form-group__toggler"
            @click="infoOpened = infoOpened ? false : true"
          >
            {{ $t("vaseInformaceOZarizeni") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: infoOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">
                {{ $t("nazevZarizeni") }}
              </span>
              <div
                :class="{
                  'has-error': error.custDeviceName
                }"
                class="side-box__content__input custom-control__custom-input ml-3"
              >
                <span v-if="!editedDevice.custDeviceName" class="placeholder">
                  {{ $t("zadejteNazevZarizeni") }}
                </span>
                <input
                  v-model="editedDevice.custDeviceName"
                  autofocus
                  class="w-100"
                  maxlength="60"
                  placeholder=""
                  type="text"
                  @blur="validateCustDeviceName()"
                  @click="changedEvent"
                />
              </div>
            </div>

            <FormSelect
              :info-text="'info_import_spustitZarizeniDoRezimu'"
              :info-tooltip="'tooltip_import_spustitZarizeniDoRezimu'"
              :items="stateOptions"
              :label="$t('prepnoutDoRezimu')"
              :value="
                selectedState.value
                  ? stateOptions.find((op) => op.value === selectedState.value)
                  : stateOptions.find((op) => op.statusText === editedDevice.status)
              "
              class="mb-3"
              item-text="text"
              item-value="value"
              side-box
              @change="
                stateOptions.find((op) => op.value === $event.value).statusText !== editedDevice.status
                  ? (selectedState = $event)
                  : (selectedState = '')
              "
            />

            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label mt-4 pt-4">
                {{ $t("CONNECTED_TO_DATA_FLOW") }}
              </span>
              <div class="side-box__content__input ml-3 border-top pt-4">
                <FormSelect
                  v-if="selectedDataFlowList.length <= 1"
                  :custom-action-text="$t('CREATE_NEW_DATA_FLOW')"
                  :has-error="error.dataFlows"
                  :items="dataFlowList"
                  :placeholder="$t('IMPORT_DEVICE_DATA_FLOW_SELECT_PLACEHOLDER')"
                  :value="selectedDataFlowList[0]"
                  item-subtext="technology"
                  item-text="deviceGroupName"
                  item-value="deviceGroupId"
                  @blur="validateDataFlows"
                  @change="handleDataFlowChanged($event, false)"
                  @custom-action-clicked="
                    $router.push({
                      name: 'dataFlowNew',
                      params: $router.params
                    })
                  "
                  @mouseup="handleDataFlowSelectClick"
                />
                <FormSelectMultiple
                  v-else
                  :custom-action-text="$t('CREATE_NEW_DATA_FLOW')"
                  :has-error="error.dataFlows"
                  :items="dataFlowList"
                  :placeholder="$t('IMPORT_DEVICE_DATA_FLOW_SELECT_PLACEHOLDER')"
                  :value="selectedDataFlowList"
                  item-subtext="technology"
                  item-text="deviceGroupName"
                  item-value="deviceGroupId"
                  @blur="validateDataFlows"
                  @change="handleDataFlowChanged($event, true)"
                  @custom-action-clicked="
                    $router.push({
                      name: 'dataFlowNew',
                      params: $router.params
                    })
                  "
                />
              </div>
            </div>

            <div class="d-flex side-box__row align-items-start mt-4">
              <span class="side-box__content__label">
                {{ $t("TRANSFORMATION_FUNCTION") }}
              </span>
              <div v-if="!isTFLoading" class="w-100 side-box__content__input side-box__content__input--large ml-3">
                <FormSelect
                  clearable
                  class="mb-4"
                  :has-error="false"
                  item-text="label"
                  item-value="transformationId"
                  item-subtext="description"
                  :items="loadedTransforms ?? []"
                  :placeholder="$t('noTransformFunction')"
                  label=""
                  :value="loadedTransforms?.find((tf) => tf.transformationId === editedDevice.transformationId)"
                  @change="editedDevice.transformationId = $event.transformationId"
                  @clear="editedDevice.transformationId = null"
                />
              </div>
              <Loader v-else class="w-100 side-box__content__input side-box__content__input--large ml-3" />
            </div>

            <div class="side-box__row d-flex align-items-center">
              <span class="side-box__content__label" />
              <div class="side-box__content__input ml-3 pb-3 border-top mt-1" />
            </div>
            <UserAttributesField
              :attributes="device.attributes"
              :edited-device-id="device.deviceId"
              @change="userAttributesChanged"
            />

            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">
                {{ $t("pridatTagy") }}
              </span>
              <div
                :class="{
                  'has-error': error.custDeviceName
                }"
                class="side-box__content__input ml-3 border-top pt-4"
              >
                <FormSelectMultiple
                  :info-text="'info_import_tagy'"
                  :info-tooltip="'tooltip_import_tagy'"
                  :items="tagOptions"
                  :placeholder="$t('vyberteTagZeSeznamu')"
                  :value="selectedTags"
                  item-text="text"
                  item-value="text"
                  @change="handleTagsChanged"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="my-4">
          <a
            :class="{ opened: servicesLimitsOpened }"
            class="atom-form-group__toggler"
            @click="servicesLimitsOpened = servicesLimitsOpened ? false : true"
          >
            {{ $t("sluzbaALimity") }}
            <img class="atom-form-group__toggler__arrow" src="@/assets/icons/arrows/arr-orange-down.svg" />
          </a>

          <div :class="{ opened: servicesLimitsOpened }" class="atom-form-group__content">
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label mb-4">
                {{ $t("sluzba") }}
              </span>
              <div
                :class="{
                  'has-error': error.custDeviceName
                }"
                class="side-box__content__input ml-3"
              >
                <FormSelect
                  :has-error="error.custServiceId"
                  :info-text="'info_import_prirazeniKeSluzbe'"
                  :info-tooltip="'tooltip_import_prirazeniKeSluzbe'"
                  :items="activeServiceList"
                  :value="selectedService"
                  item-subtext="custServiceId"
                  item-text="custServiceName"
                  item-value="custServiceId"
                  @change="handleServiceChanged"
                />
              </div>
            </div>
            <div class="side-box__row d-flex justify-content-center">
              <div
                :class="{
                  'has-error': error.custDeviceName
                }"
                class="side-box__content__input ml-3"
              >
                <ServiceLimits v-if="selectedService" :service="selectedService" />

                <p class="mt-3">
                  {{ $t("sluzbuMuzeteZmenit") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SaveConfirmationModal
      :opened="openedEditConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="openedEditConfirmation"
      @no="closeBox('editMqttDevice')"
      @yes="runEdit()"
    />

    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal
        :centered="true"
        :errors="errorsToTranslate"
        :opened="openedError"
        @close="
          () => {
            closeBox('editDevice')
            openedError = false
          }
        "
      />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import FormSelect from "@/components/forms/FormSelect.vue"
import { mapActions, mapGetters, mapState } from "vuex"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import ServiceLimits from "@/components/boxes/serviceLimits.vue"
import UserAttributesField from "@/components/devices/userAttributesField.vue"
import HwDeviceField from "@/components/devices/partials/HwDeviceField.vue"
import Loader from "@/components/loader.vue"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"

export default {
  components: {
    Loader,
    HwDeviceField,
    FormSelectMultiple,
    FormSelect,
    SaveConfirmationModal,
    ErrorModal,
    ServiceLimits,
    UserAttributesField
  },
  props: {
    opened: Array,
    device: Object
  },
  setup() {
    const projectStore = useProjectStore()
    const authStore = useAuthStore()
    const tfStore = useTransformationFunctionsStore()

    return { projectStore, authStore, tfStore }
  },
  data() {
    return {
      changed: false,
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      lastDevice: {},
      transformations: {},
      openedError: false,
      transformationOpened: false,
      selectedTransformation: {},
      errorsToTranslate: [],
      openedEditConfirmation: false,
      infoOpened: true,
      errors: {
        device: ""
      },
      error: {
        custDeviceName: false,
        dataFlows: false
      },
      selectedService: {},
      selectedState: {},
      selectedTags: [],
      preregistrationAllowed: false,
      dataFlowList: [],
      selectedDataFlowList: [],
      newParamOpened: false,
      parameterTypeOpened: false,
      loadedTransforms: [],
      servicesLimitsOpened: false,
      userAttributes: [],
      hiddenTags: [],
      editedDevice: {}
    }
  },
  async created() {
    if (this.device) {
      this.editedDevice = Object.assign({}, this.device)
    }
    this.loadTransforms()

    await this.projectStore.getAllTags(this.$route.params.projectId)
    this.getServices(this.$route.params.projectId)
    this.loadDataFlows()

    this.selectedService = this.activeServiceList.find((s) => s.custServiceId === this.device.custServiceId)
    this.selectedTags = this.editedDevice.tags
      .concat()
      .filter((tag) => this.tagList.includes(tag))
      .map((tag) => {
        return { text: tag }
      })
    this.hiddenTags = this.editedDevice.tags
      .concat()
      .filter((tag) => !this.tagList.includes(tag))
      .map((tag) => {
        return { text: tag }
      })
    this.selectedDataFlowList = this.device.deviceGroups

    if (!this.device.suspended && this.device.enabled) {
      this.selectedState = {
        atomCircleClass: "atom-circle--success",
        text: this.$t("active"),
        value: "A"
      }
    } else if (!this.device.enabled) {
      this.selectedState = {
        atomCircleClass: "atom-circle--gray",
        text: this.$t("Standby"),
        value: "S"
      }
    }
  },
  computed: {
    ...mapState({
      serviceList: (state) =>
        state.services.services.filter((s) => !s.suspended && !s.discontinued && s.productElementId !== "s_iot8681")
    }),
    transformationFunctionList() {
      return this.tfStore.list
    },
    isTFLoading() {
      return this.tfStore.isLoading
    },
    tagList() {
      return this.projectStore.tagList
    },
    activeServiceList() {
      return this.serviceList.filter((s) => !s.suspended && !s.discontinued)
    },
    project() {
      return this.projectStore.selectedProject
    },
    apiUser() {
      return this.authStore.apiUser
    },
    tagOptions() {
      return this.tagList.map((tag) => {
        return { text: tag }
      })
    },
    stateOptions() {
      return [
        ...(!this.device.suspended
          ? [
              {
                atomCircleClass: "atom-circle--success",
                text: this.$t("active"),
                value: "A",
                statusText: "active"
              }
            ]
          : [
              {
                atomCircleClass: "atom-circle--warning",
                text: this.$t("overLimit"),
                value: "A",
                atomCircleText: "O",
                statusText: "suspended"
              }
            ]),
        {
          atomCircleClass: "atom-circle--gray",
          text: this.$t("Standby"),
          value: "S",
          statusText: "standby"
        },
        ...(this.preregistrationAllowed
          ? [
              {
                atomCircleClass: "atom-circle--warning",
                text: this.$t("PREDREGISTRACE"),
                value: "P",
                statusText: "preregistration"
              }
            ]
          : [])
      ]
    }
  },
  watch: {
    project() {
      this.loadGroups()
      this.setProject()
      this.loadService()
      this.loadTransforms()
    },
    opened() {},
    selectedService(service) {
      if (!service) {
        return
      }

      this.preregistrationAllowed = false
      this.editedDevice.selectedState = this.stateOptions[0]

      const PREREGISTRATION_MSGS = service.parameters.find(
        (p) => p.name === "COUNTER-PREREGISTRATION_MSGS" && p.value > 0
      )
      const PREREGISTRATION_DAYS = service.parameters.find(
        (p) => p.name === "COUNTER-PREREGISTRATION_DAYS" && p.value > 0
      )

      if (PREREGISTRATION_MSGS || PREREGISTRATION_DAYS) {
        this.preregistrationAllowed = true
      }
    },
    "device.selectedState": function () {
      this.selectedState = this.device.selectedState
    },
    device() {
      if (this.device) {
        this.loadTransforms()
        this.editedDevice = Object.assign({}, this.device)
      }
    }
  },
  methods: {
    ...mapActions({
      getServices: "services/getLoraServices"
    }),
    getTransformationFunctionList() {
      return this.tfStore.getList()
    },
    changedEvent() {
      this.changed = true
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      this.$emit("closeBox", box)
    },
    setProject() {
      this.newGroup.projectId = this.project.projectId
    },
    showWaiting() {
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
    },
    hideWaiting() {
      this.$store.commit("modals/setWaitingLoader", "")
    },
    async runEdit() {
      this.errorsToTranslate = []

      if (!this.validateCustDeviceName() || !this.validateDataFlows()) {
        return
      }

      this.showWaiting()

      let editDevice = await this.editDevice()
      let editService = await this.editService()
      let editStatus = await this.editStatus()
      let editTags = await this.editTags()
      let editGroups = await this.editGroups()
      let editAttributes = await this.editAttributes()

      if (editDevice && editService && editStatus && editTags && editGroups && editAttributes) {
        this.hideWaiting()
        if (this.errorsToTranslate.length > 0) {
          this.openedError = true
          this.$emit("reloadItems")
          this.$emit("updateItems")
        } else {
          this.$emit("reloadItems")
          this.$emit("updateItems")
          this.$emit("closeBox", "editMqttDevice")
        }
      }
    },
    async editAttributes() {
      let attributes = this.userAttributes.reduce((acc, { title, value }) => {
        acc[title] = value
        return acc
      }, {})

      try {
        await axios.put(
          `${process.env.VUE_APP_API}/mqtt/devices/${this.editedDevice.deviceId}/attributes`,
          attributes,
          {}
        )
        this.editedDevice.attributes = attributes
      } catch (error) {
        this.errorsToTranslate.push(error.data)
      }

      return true
    },
    async editGroups() {
      const selectedIds = this.selectedDataFlowList.map((group) => group.deviceGroupId)
      const previousIds = this.device.deviceGroups.map((group) => group.deviceGroupId)

      for (const group of this.device.deviceGroups) {
        if (selectedIds.includes(group.deviceGroupId)) {
          continue
        }

        try {
          await axios.delete(
            `${process.env.VUE_APP_API}/device-groups/${group.deviceGroupId}/devices/mqtt/${this.editedDevice.deviceId}/assign`,
            {}
          )
        } catch (e) {
          this.errorsToTranslate.push(e.data)
        }
      }

      for (const group of this.selectedDataFlowList) {
        if (previousIds.includes(group.deviceGroupId)) {
          continue
        }

        try {
          await axios.post(
            `${process.env.VUE_APP_API}/device-groups/${group.deviceGroupId}/devices/mqtt/${this.editedDevice.deviceId}/assign`,
            {}
          )
        } catch (e) {
          this.errorsToTranslate.push(e.data)
        }
      }

      return true
    },
    async editTags() {
      try {
        await axios.put(
          `${process.env.VUE_APP_API}/mqtt/devices/${this.editedDevice.deviceId}/tags`,
          this.selectedTags.concat(this.hiddenTags).map((t) => t.text),
          {}
        )
        this.editedDevice.tags = this.selectedTags.concat(this.hiddenTags)
      } catch (error) {
        this.errorsToTranslate.push(error.data)
      }

      return true
    },
    async editStatus() {
      if (this.selectedState.value !== "") {
        if (this.selectedState.value === "A" || this.selectedState.value === "P") {
          let action = "enable"
          if (this.editedDevice.status === "preregistration" && this.editedDevice.enabled) {
            action = "activate"
          }

          try {
            await axios.post(`${process.env.VUE_APP_API}/mqtt/devices/${this.editedDevice.deviceId}/${action}`, {})
            this.editedDevice.enabled = true
          } catch (error) {
            this.errorsToTranslate.push(error.data)
          }
        } else if (this.selectedState.value === "S") {
          try {
            await axios.delete(`${process.env.VUE_APP_API}/mqtt/devices/${this.editedDevice.deviceId}/enable`, {})
            this.editedDevice.enabled = false
          } catch (error) {
            this.errorsToTranslate.push(error.data)
          }
        }
      }
      return true
    },
    async editDevice() {
      if (this.editedDevice.custDeviceName) {
        try {
          await axios.put(
            `${process.env.VUE_APP_API}/mqtt/devices/${this.editedDevice.deviceId}`,
            {
              custDeviceName: this.editedDevice.custDeviceName,
              transformationId: this.editedDevice.transformationId,
              custServiceId: this.editedDevice.custServiceId
            },
            {}
          )
        } catch (error) {
          this.errorsToTranslate.push(error.data)
        }
        return true
      } else {
        this.errors.device = this.$t("fillAllFieldsError")
      }
    },
    async editService() {
      if (this.editedDevice.custServiceId !== this.device.custServiceId) {
        try {
          await axios.post(
            `${process.env.VUE_APP_API}/services/${this.editedDevice.custServiceId}/devices/mqtt/${this.editedDevice.deviceId}/assign`,
            {}
          )
        } catch (e) {
          this.errorsToTranslate.push(e.data)
        }
      }

      return true
    },
    async loadDataFlows() {
      const response = await axios.get(
        `${process.env.VUE_APP_API}/device-groups?projectId[eq]=${this.$route.params.projectId}&limit=1000&sort=%2BdeviceGroupName`
      )
      this.dataFlowList = response.data.data.filter((df) => df.technology === "MQTT")
    },
    handleTransformChanged(transform) {
      this.editedDevice.transformationId = transform.transformationId
    },
    toggleEditConfirmation() {
      if (this.changed) {
        this.openedEditConfirmation = !this.openedEditConfirmation
      } else {
        this.openedEditConfirmation = false
        this.$emit("closeBox", "editMqttDevice")
      }
    },
    validateCustDeviceName() {
      if (!this.editedDevice.custDeviceName) {
        this.error.custDeviceName = true
        return false
      } else {
        this.error.custDeviceName = false
        return true
      }
    },
    validateDataFlows() {
      if (!this.selectedDataFlowList.length) {
        this.error.dataFlows = true
        return false
      }
      this.error.dataFlows = false
      return true
    },
    handleServiceChanged(service) {
      this.editedDevice.custServiceId = service.custServiceId
      this.selectedService = this.activeServiceList.find((s) => s.custServiceId === this.editedDevice.custServiceId)

      this.preregistrationAllowed = false
      this.selectedState = this.stateOptions[0]

      const PREREGISTRATION_MSGS = service.parameters.find(
        (p) => p.name === "COUNTER-PREREGISTRATION_MSGS" && p.value > 0
      )
      const PREREGISTRATION_DAYS = service.parameters.find(
        (p) => p.name === "COUNTER-PREREGISTRATION_DAYS" && p.value > 0
      )

      if (PREREGISTRATION_MSGS || PREREGISTRATION_DAYS) {
        this.preregistrationAllowed = true
      }
    },
    handleTagsChanged(tags) {
      this.selectedTags = tags
    },
    handleDataFlowChanged(value, isMultiple) {
      this.selectedDataFlowList = isMultiple ? value : [value]
    },
    handleDataFlowSelectClick({ value, nativeEvent }) {
      if (nativeEvent.ctrlKey) {
        this.selectedDataFlowList = [...this.selectedDataFlowList, value]
      }
    },
    async loadTransforms() {
      let params = {
        "type[eq]": "IN",
        "sort[eq]": "label",
        "subType[eq]": "MQTT",
        "projectId[eq]": this.$route.params.projectId
      }
      await this.getTransformationFunctionList(params)
      const projectTransforms = [...this.transformationFunctionList]
      params = {
        "type[eq]": "IN",
        "sort[eq]": "label",
        "subType[eq]": "MQTT",
        "public[eq]": true
      }
      await this.getTransformationFunctionList(params)
      this.loadedTransforms = [...projectTransforms, ...this.transformationFunctionList]
    },
    userAttributesChanged(newVal) {
      this.userAttributes = newVal
      this.changedEvent()
    }
  }
}
</script>

<style lang="scss" scoped></style>
